import Vue from 'vue'
import Vuex from 'vuex'
import hintText from "./hintText/index.js";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    hintText
  }
})
